<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Add Account Authorization Request</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <mat-form-field class="full-width-formField bar">
      <mat-label>Reason</mat-label>
      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10" [(ngModel)]="reason" name="reason"></textarea>
    </mat-form-field>

    @if (isAllowSelfApprove == true) {
      <div class="group">
        <!--Date-->
        <mat-form-field class="full-width-formField bar">
          <input matInput class="textInputLong" [matDatepicker]="myDatepicker" name="date" [(ngModel)]="date" placeholder="Date" [min]="sharedService.getTodayDate()" onkeydown="return false;" />
          <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #myDatepicker name="date"></mat-datepicker>
        </mat-form-field>
      </div>
      <!--Remark-->
      <div class="group">
        <input type="text" required class="textInputLong" name="remark" [(ngModel)]="grantRemark" />
        <span class="highlight"></span>
        <span class="bar barLong"></span>
        <label> Grant Remark</label>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disabledSubmit">Submit</button>
    <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
  </div>
</form>
